namespace Areas {
    "use strict";

    declare var CKEDITOR: any;

    export function ckeditorInit(elementId, readonly?) {

        if ($('#' + elementId).length > 0) {
            CKEDITOR.plugins.addExternal('autolink', '/js/autolink/', 'plugin.js');
            var config: any = { extraPlugins: 'autolink', removeButtons: 'About' };
            if ($('#' + elementId).is('[readonly]') || readonly) {
                config.toolbar = [['Copy', 'Maximize', 'Source', 'Link', 'Unlink']];
                CKEDITOR.on('instanceReady', function (ev) {
                    $('iframe').contents().click(function (e: any) {
                        var url;
                        url = e.target.href;
                        if (url !== undefined && url !== "") {
                            window.open(url);
                        }
                    });
                });
            }
            if (readonly) config.readOnly = true;
            CKEDITOR.replace(elementId, config);
        }
    }

    export function ckeditorGet(elementId) {

        return CKEDITOR.instances[elementId].getData();
    }

    export function ckeditorSet(elementId, value) {

        CKEDITOR.instances[elementId].setData(value);
    }
}